import { useAuth } from '../context/AuthContext';

/** The standard module access hook; when nothing gates the module every flag is true, so unconfigured systems behave as before. */
export function useModuleAccess(prefix) {
  const { hasPermission, isPermissionGated } = useAuth();
  const viewCode   = `${prefix}.view`;
  const editCode   = `${prefix}.edit`;
  const createCode = `${prefix}.create`;

  const viewGated   = isPermissionGated(viewCode);
  const editGated   = isPermissionGated(editCode);
  const createGated = isPermissionGated(createCode);

  return {
    canView:   !viewGated   || hasPermission(viewCode),
    canEdit:   !editGated   || hasPermission(editCode),
    canCreate: !createGated || hasPermission(createCode),
    gated: viewGated || editGated || createGated,
    codes: { view: viewCode, edit: editCode, create: createCode },
  };
}
